import * as T from '../types';
import { PaymentGate } from '../types';

const setPaymentGates = (paymentGates: PaymentGate[]) => {
  return { type: T.SET_PAYMENT_GATES, paymentGates };
};

export default setPaymentGates;
